import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseValueAccessor } from 'src/app/core/base/base.value-accessor';
import { OdontoHistoryViewModel } from 'src/app/model/odonto/history.view';
import esTranslation from 'src/assets/translations/es.json';

@Component({
  selector: 'ms-odonto-history',
  templateUrl: './odonto.history.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: OdontoHistoryComponent,
      multi: true,
    },
  ],
})
export class OdontoHistoryComponent extends BaseValueAccessor<
  OdontoHistoryViewModel[]
> {
  readonly screen = esTranslation;
  @Input() turn = -1;
  @Input() readonly = false;

  showDetails = false;
  expandSection = true;

  handleUpdateGlobalField = ($ev: OdontoHistoryViewModel) => {};

  get mainDetail() {
    if (!this.value) {
      return undefined;
    }
    return this.value.find((item) => item.id === 'odo_his_00');
  }

  get catalogs() {
    if (!this.value) {
      return [];
    }
    return this.value.filter((item) => item.id !== 'odo_his_00');
  }

  get catalogsName() {
    return this.catalogs
      .filter((item) => item.details && item.details?.trim().length > 0)
      .map((item) => item.name)
      .join('; ');
  }
}
